"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateIn91Days = exports.getDateIn90Days = exports.getFutureDate = exports.getEarlierDate = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
exports.getEarlierDate = function (date) {
    return moment_timezone_1.default(date)
        .subtract(2, 'days')
        .tz('America/Toronto')
        .format('YYYY-MM-DD');
};
exports.getFutureDate = function (date) {
    return moment_timezone_1.default(date)
        .add(1, 'days')
        .tz('America/Toronto')
        .format('YYYY-MM-DD');
};
exports.getDateIn90Days = function (date) {
    return moment_timezone_1.default(date)
        .add(90, 'days')
        .tz('America/Toronto')
        .format('YYYY-MM-DD');
};
exports.getDateIn91Days = function (date) {
    return moment_timezone_1.default(date)
        .add(91, 'days')
        .tz('America/Toronto')
        .format('YYYY-MM-DD');
};
